import axios from 'axios'
import { URIS, loadHeaders } from '../Uris'
import { errorMessage } from '../helpers'

export const FETCH_COURSES = 'FETCH_COURSES'
export const FETCH_COURSES_SUCCESS = 'FETCH_COURSES_SUCCESS'
export const FETCH_COURSES_FAILURE = 'FETCH_COURSES_FAILURE'
export const SAVE_COURSES_SUCCESS = 'SAVE_COURSES_SUCCESS'
export const SAVE_COURSES_FAILURE = 'SAVE_COURSES_FAILURE'
export const COURSES_AJAX_CALL = 'COURSES_AJAX_CALL'
export const COURSES_CLEAR_AJAX_CALL = 'COURSES_CLEAR_AJAX_CALL'
export const DELETE_COURSES_SUCCESS = 'DELETE_COURSES_SUCCESS'
export const DELETE_COURSES_FAILURE = 'DELETE_COURSES_FAILURE'

export function loadCourses() {
  return (dispatch) => {
    dispatch(fetchCourses())
    axios({
      method: 'GET',
      url: URIS.courses,
      headers: loadHeaders()
    })
      .then((res) => {
        dispatch(fetchCoursesSuccess(res.data))
      })
      .catch((error) => {
        dispatch(fetchCoursesFailure(errorMessage(error)))
      })
  }
}

function fetchCourses() {
  return {
    type: FETCH_COURSES
  }
}

function fetchCoursesSuccess(payload) {
  return {
    type: FETCH_COURSES_SUCCESS,
    payload
  }
}

function fetchCoursesFailure(payload) {
  return {
    type: FETCH_COURSES_FAILURE,
    payload
  }
}

export function saveCourses(payload) {
  return (dispatch) => {
    dispatch(loadingAjaxCall())
    axios({
      method: 'POST',
      url: URIS.courses,
      headers: loadHeaders(),
      data: payload
    })
      .then((res) => {
        dispatch(saveCoursesSuccess(res.data))
      })
      .catch((error) => {
        dispatch(saveCoursesFailure(errorMessage(error)))
      })
  }
}

function saveCoursesSuccess(payload) {
  return {
    type: SAVE_COURSES_SUCCESS,
    payload
  }
}

function saveCoursesFailure(payload) {
  return {
    type: SAVE_COURSES_FAILURE,
    payload
  }
}

export function deleteCourses(payload) {
  return (dispatch) => {
    dispatch(loadingAjaxCall())
    axios({
      method: 'DELETE',
      url: URIS.courses,
      headers: loadHeaders(),
      data: payload
    })
      .then((res) => {
        dispatch(deleteCoursesSuccess(res.data.data))
      })
      .catch((error) => {
        dispatch(deleteCoursesFailure(errorMessage(error)))
      })
  }
}

function deleteCoursesSuccess(payload) {
  return {
    type: DELETE_COURSES_SUCCESS,
    payload
  }
}

export function deleteCoursesFailure(payload) {
  return {
    type: DELETE_COURSES_FAILURE,
    payload
  }
}

function loadingAjaxCall() {
  return {
    type: COURSES_AJAX_CALL
  }
}

export function clearAjaxCall(payload) {
  return {
    type: COURSES_CLEAR_AJAX_CALL
  }
}



// WEBPACK FOOTER //
// ./src/actions/Courses.js